var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.52,
    height: 15,
    viewBox: "0 0 23.52 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow_Left",
    "data-name": "Arrow Left",
    d: "M2.5,23.52a2.57,2.57,0,0,0,1.768-.689l10-9.408a2.254,2.254,0,0,0,0-3.326L4.267.689a2.612,2.612,0,0,0-3.535,0,2.254,2.254,0,0,0,0,3.326L8.964,11.76.732,19.505a2.254,2.254,0,0,0,0,3.326A2.57,2.57,0,0,0,2.5,23.52",
    transform: "translate(23.52) rotate(90)",
    fill: "#1D1D26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownYellow);
export default __webpack_public_path__ + "static/media/ArrowDownYellow.04bbecb1c84b1a3cd48fe45da8ad9f15.svg";
export { ForwardRef as ReactComponent };